// extracted by mini-css-extract-plugin
export default {"tag":"styles_tag__hSlZB","tag__delete":"styles_tag__delete__rHTxi"};